import React, {Component} from "react";
import Title from "../../components/Title";
import Breadcrumbs from "../../components/UI/Breadcrumbs";
import Layout from "../../containers/Layout";
import ScheduleOutput from "../../containers/ScheduleOutput";


class SchedulesPage extends Component {
    render() {
        return (
            <Layout>
                <Title>Расписание</Title>
                <Breadcrumbs links={[
                    {name: 'Главная', url: '/'},
                    {name: 'Расписание', url: '/schedules'}
                ]}/>
                <ScheduleOutput/>
            </Layout>
        );
    }
}

export default SchedulesPage;
